import { contacts } from './contacts/contacts';

export const about = () => {
  contacts();
};
